import React, {Component} from "react";
import {Grid, Row, Col, FormGroup, ControlLabel, FormControl, InputGroup, Glyphicon, Well} from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import apiClient from "api/client";
import {css} from "@emotion/core";
import {ScaleLoader} from 'react-spinners';
import {Redirect} from "react-router";
import Button from "../../components/CustomButton/CustomButton";
import ModalSave from "../../components/CustomModals/ModalSave";
import {DualListBoxPackageLive} from "../../components/DualListBox/DualListBoxPackageLive";
import 'react-dual-listbox/lib/react-dual-listbox.css';
import {userActions} from "../../authentication/_actions";
import Switch from "components/CustomSwitch";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import ImageUpload from "../../components/ImageUpload/ImageUpload";
import NotificationSystem from "react-notification-system";
import {style} from "../../variables/Variables";
import {DropDownContentProviders} from "../../components/CustomDropDown/DropDownContentProviders";
import {DropDownLiveTvPriceList} from "../../components/CustomDropDown/DropDownLiveTvPriceList";
import {DropDownCountries} from "../../components/CustomDropDown/DropDownCountries";
import Select from "react-select";

const override = css`
    position: fixed;
    left: 50%;
    top: 35%;
    display: block;
    z-index: 1000;
    height: 31px;
    width: 100px;
`;

const adminArray = ['super-admin', 'admin']

const DeviceTypeOptions = [
    {value: 'android_mobile', label: 'Android'},
    {value: 'android_tv', label: 'Android TV'},
    {value: 'ios_mobile', label: 'iOS'},
    {value: 'roku', label: 'Roku'},
    {value: 'web', label: 'Web'},
];

class EditPackagesLive extends Component {

    constructor(props) {
        super(props);
        this.state = {

            loading: false,

            redirect: false,
            livePackageRedirect: false,

            back_button_text: "Cancel",
            showSaveModal: false,

            livePackageObject: [],

            livepackage_id: 0,
            livepackage_name: null,
            livepackage_name_long: null,
            livepackage_description: null,
            livepackage_status: false,
            livepackage_price: 0.0,
            livepackage_is_adult: false,
            livepackage_no_expiry: false,
            livepackage_channels_assign: null,
            livepackage_display_while_inactive: false,
            livepackage_billing_code: null,
            livepackage_time_limit: null,
            livepackage_duration: null,
            livepackage_device_limit: null,
            livepackage_subscription_url: null,
            livepackage_trial: null,

            livepackage_image: null,
            livepackage_image_temp: false,
            livepackage_image_folder_temp: "",

            livepackage_inactive_image_temp: false,
            livepackage_inactive_image: null,
            livepackage_inactive_image_folder_temp: "",

            assignedChannelsInPackage: [],

            statusSwitch: false,
            adultSwitch: false,
            expirySwitch: false,
            trialSwitch: false,

            _notificationSystem: null,

            livepackage_content_provider: null,
            current_user: null,
            user_content_provider: null,
            custom_data: null,

            livepackage_credit_card_status: false,
            livepackage_credit_card_product_id: null,
            livepackage_credit_card_control_text: null,
            livepackage_credit_card_help_url: null,

            livepackage_code_status: false,
            livepackage_code_control_text: null,
            livepackage_code_help_url: null,

            livepackage_account_status: false,
            livepackage_account_control_text: null,
            livepackage_account_help_url: null,

            live_pgroups: [],
            live_pgroups_cards: null,
            live_pgroups_codes: null,

            creditCardSwitch: false,
            codeSwitch: false,
            accountSwitch: false,

            countryBlockSwitch: false,
            addAllCountriesInCountryBlock: false,
            livepackage_country_block_countries: null,

            accessVisibilitySwitch: false,
            livepackage_device_type_visibility: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleLivePackageChannelChange = this.handleLivePackageChannelChange.bind(this);
        this.handleChildContentProviderSelect = this.handleChildContentProviderSelect.bind(this);
        this.handleChildImageSelect = this.handleChildImageSelect.bind(this);

        this.handleChildLivePriceGroupsCodesSelected = this.handleChildLivePriceGroupsCodesSelected.bind(this);
        this.handleChildLivePriceGroupsCreditCardSelected = this.handleChildLivePriceGroupsCreditCardSelected.bind(this);
        this.handleChildCountryBlockSelect = this.handleChildCountryBlockSelect.bind(this);
        this.handleDeviceTypeChange = this.handleDeviceTypeChange.bind(this);


    }

    handleDeviceTypeChange = (data) => {

        console.log(`Option selected:`, data);

        let deviceTypeIds = []

        for (let i = 0; i < data.length; i++) {
            deviceTypeIds.push(data[i].value)
        }

        this.setState({
            livepackage_device_type_visibility: data === null ? 0 : deviceTypeIds
        });

    }

    handleChildLivePriceGroupsCreditCardSelected(data) {

        if (data !== undefined) {
            let selectedIds = []
            let selectedNames = []

            for (let i = 0; i < data.length; i++) {
                selectedIds.push(data[i].value)
            }

            for (let i = 0; i < data.length; i++) {
                selectedNames.push(data[i].label)
            }

            this.setState({
                live_pgroups_cards: data === null ? null : selectedIds,
            });
        }
    }

    handleChildLivePriceGroupsCodesSelected(data) {

        if (data !== undefined) {
            let selectedIds = []
            let selectedNames = []

            for (let i = 0; i < data.length; i++) {
                selectedIds.push(data[i].value)
            }

            for (let i = 0; i < data.length; i++) {
                selectedNames.push(data[i].label)
            }

            this.setState({
                live_pgroups_codes: data === null ? null : selectedIds,
            });
        }
    }

    handleChildImageSelect(folder, filename, imagePosition) {

        if (imagePosition === "livepackage_image") {
            this.setState({
                livepackage_image_temp: filename !== null,
                livepackage_image: filename,
                livepackage_image_folder_temp: folder
            });
        }
        if (imagePosition === "livepackage_inactive_image") {
            this.setState({
                livepackage_inactive_image_temp: filename !== null,
                livepackage_inactive_image: filename,
                livepackage_inactive_image_folder_temp: folder
            });
        }

    }

    handleChildContentProviderSelect(data) {

        if (data !== undefined) {
            this.setState({
                user_content_provider: data === null ? null : data.value,
                assignedChannelsInPackage: []
            });
        }
    }

    handleLivePackageChannelChange(selectedFromChild) {

        let selectedChannels = []

        if (selectedFromChild !== undefined !== null) {

            for (let i = 0; i < selectedFromChild.length; i++) {
                //console.log(selectedFromChild[i].toString())
                selectedChannels.push(selectedFromChild[i].toString())
            }
        }

        this.setState({assignedChannelsInPackage: selectedChannels})
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSwitch(elem, state) {
        if (elem.props.name === 'statusSwitch') {
            this.setState({statusSwitch: state})
        }
        if (elem.props.name === 'expirySwitch') {
            this.setState({expirySwitch: state})
        }
        if (elem.props.name === 'adultSwitch') {
            this.setState({adultSwitch: state})
        }
        if (elem.props.name === 'trialSwitch') {
            this.setState({trialSwitch: state})
        }
        if (elem.props.name === 'creditCardSwitch') {
            if (state) {
                this.setState({creditCardSwitch: state})
            } else {
                this.setState({creditCardSwitch: state})
            }
        }

        if (elem.props.name === 'codeSwitch') {
            if (state) {
                this.setState({codeSwitch: state})
            } else {
                this.setState({codeSwitch: state})
            }
        }

        if (elem.props.name === 'accountSwitch') {
            if (state) {
                this.setState({accountSwitch: state})
            } else {
                this.setState({accountSwitch: state})
            }
        }

        if (elem.props.name === 'countryBlockSwitch') {
            this.setState({countryBlockSwitch: state})
        }

        if (elem.props.name === 'accessVisibilitySwitch') {
            this.setState({accessVisibilitySwitch: state})
        }
    }

    componentDidMount() {

        this.setState({_notificationSystem: this.refs.notificationSystem})

        const {handle} = this.props.match.params

        if (handle === 'new') {
            let user = JSON.parse(localStorage.getItem('user'));
            this.setState({loading: false, current_user: user})
        } else {

            this.setState({loading: true})
            const url = process.env.REACT_APP_API_URL + "/LivePackage/" + handle;

            let user = JSON.parse(localStorage.getItem('user'));
            let token = ""

            if (user) {
                token = user.token
            } else {
                this.props.dispatch(userActions.logoutUnauthorized());
            }

            let axiosConfig = {
                headers: {'X-Id-Token': token}
            };

            apiClient.get(url, axiosConfig)
                .then(res => {

                    const livePackageObject = res.data[0];
                    const loading = false;

                    //console.log(livePackageObject)

                    let selectedChannels = []

                    if (livePackageObject.livepackage_channels_assign !== null) {
                        selectedChannels = livePackageObject.livepackage_channels_assign.toString().split(",")
                    } else {
                        selectedChannels = []
                    }

                    let groupCardIds = []

                    if (livePackageObject.livepackage_pgroups_cards !== null) {
                        let temp = livePackageObject.livepackage_pgroups_cards.toString();
                        groupCardIds = temp.split(",")
                    }

                    let groupCodeIds = []

                    if (livePackageObject.livepackage_pgroups_codes !== null) {
                        let temp = livePackageObject.livepackage_pgroups_codes.toString();
                        groupCodeIds = temp.split(",")
                    }

                    let countriesBlocked = []
                    if (livePackageObject.livepackage_country_block_countries !== null) {
                        let tempCountry = livePackageObject.livepackage_country_block_countries.toString();
                        countriesBlocked = tempCountry.split(",")
                    }

                    let status = livePackageObject.livepackage_status === 1
                    let adultSwitch = livePackageObject.livepackage_is_adult === 1
                    let expirySwitch = livePackageObject.livepackage_no_expiry === 1
                    let trialSwitch = livePackageObject.livepackage_trial === 1
                    let creditCardSwitch = livePackageObject.livepackage_credit_card_status === 1
                    let codeSwitch = livePackageObject.livepackage_code_status === 1
                    let accountSwitch = livePackageObject.livepackage_account_status === 1
                    let countryBlockSwitch = livePackageObject.livepackage_country_block_status === 1
                    let accessVisibilitySwitch = livePackageObject.livepackage_access_visibility === 1

                    //console.log(selectedChannels)

                    this.setState({
                        back_button_text: "Back",
                        livepackage_id: livePackageObject.livepackage_id,
                        livepackage_name: livePackageObject.livepackage_name,
                        livepackage_name_long: livePackageObject.livepackage_name_long,
                        livepackage_description: livePackageObject.livepackage_description,
                        livepackage_status: livePackageObject.livepackage_status,
                        livepackage_price: livePackageObject.livepackage_price,
                        livepackage_duration: livePackageObject.livepackage_duration,
                        livepackage_image: livePackageObject.livepackage_image,
                        livepackage_inactive_image: livePackageObject.livepackage_inactive_image,
                        livepackage_is_adult: livePackageObject.livepackage_is_adult,
                        livepackage_channels_assign: selectedChannels,
                        livepackage_display_while_inactive: livePackageObject.livepackage_display_while_inactive,
                        livepackage_billing_code: livePackageObject.livepackage_billing_code,
                        livepackage_subscription_url: livePackageObject.livepackage_subscription_url,
                        livepackage_trial: livePackageObject.livepackage_trial,
                        assignedChannelsInPackage: selectedChannels,
                        statusSwitch: status,
                        adultSwitch,
                        expirySwitch,
                        trialSwitch,
                        loading,
                        livePackageObject,
                        creditCardSwitch,
                        codeSwitch,
                        accountSwitch,
                        countryBlockSwitch,
                        accessVisibilitySwitch,
                        current_user: user,
                        user_content_provider: livePackageObject.livepackage_content_provider,
                        custom_data: livePackageObject.custom_data,

                        livepackage_credit_card_status: creditCardSwitch,
                        livepackage_credit_card_product_id: livePackageObject.livepackage_credit_card_product_id,
                        livepackage_credit_card_control_text: livePackageObject.livepackage_credit_card_control_text,
                        livepackage_credit_card_help_url: livePackageObject.livepackage_credit_card_help_url,
                        livepackage_code_status: codeSwitch,
                        livepackage_code_control_text: livePackageObject.livepackage_code_control_text,
                        livepackage_code_help_url: livePackageObject.livepackage_code_help_url,
                        livepackage_account_status: accountSwitch,
                        livepackage_access_visibility: this.state.accessVisibilitySwitch === false ? 0 : 1,
                        livepackage_account_control_text: livePackageObject.livepackage_account_control_text,
                        livepackage_account_help_url: livePackageObject.livepackage_account_help_url,
                        live_pgroups_codes: groupCodeIds,
                        live_pgroups_cards: groupCardIds,

                        livepackage_country_block_countries: countriesBlocked,
                        livepackage_device_type_visibility: livePackageObject.livepackage_device_type_visibility,
                    });
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);
                    //this.props.dispatch(userActions.logoutUnauthorized());
                });
        }
    }

    updateLivePackage() {

        this.setState({loading: true})

        const {handle} = this.props.match.params
        const url = process.env.REACT_APP_API_URL + "/LivePackage/" + handle;

        let channelsInPackage = []

        for (let i = 0; i < this.state.assignedChannelsInPackage.length; i++) {
            channelsInPackage.push(this.state.assignedChannelsInPackage[i])
        }

        let status = this.state.statusSwitch === false ? 0 : 1
        let adultSwitch = this.state.adultSwitch === false ? 0 : 1
        let expirySwitch = this.state.expirySwitch === false ? 0 : 1
        let trialSwitch = this.state.trialSwitch === false ? 0 : 1
        let creditCardSwitch = this.state.creditCardSwitch === false ? 0 : 1
        let codeSwitch = this.state.codeSwitch === false ? 0 : 1
        let accountSwitch = this.state.accountSwitch === false ? 0 : 1
        let countryBlockStatus = this.state.countryBlockSwitch === false ? 0 : 1

        //RENAME FUNCTIONS START IMAGE ACTIVE
        let filename_active = ""

        if (this.state.livepackage_image_temp) {
            let timeUTC = new Date().getTime()
            filename_active = timeUTC + "_" + this.state.livepackage_image
            this.setState({livepackage_image: filename_active})
            console.log("*****" + filename_active)
            this.submitActiveImage(filename_active);
        } else {
            filename_active = this.state.livepackage_image
        }

        //RENAME FUNCTIONS START IMAGE INACTIVE
        let filename_inactive = ""

        if (this.state.livepackage_inactive_image_temp) {
            let timeUTC = new Date().getTime()
            filename_inactive = timeUTC + "_" + this.state.livepackage_inactive_image
            this.setState({livepackage_inactive_image: filename_inactive})
            console.log("*****" + filename_inactive)
            this.submitInactiveImage(filename_inactive);
        } else {
            filename_inactive = this.state.livepackage_inactive_image
        }

        // Send a PUT request
        var postData = {
            live_package: {
                livepackage_id: this.state.livepackage_id,
                livepackage_name: this.state.livepackage_name,
                livepackage_name_long: this.state.livepackage_name_long,
                livepackage_description: this.state.livepackage_description,
                livepackage_status: status,
                livepackage_price: this.state.livepackage_price,
                livepackage_duration: this.state.livepackage_duration,
                livepackage_image: filename_active,
                livepackage_inactive_image: filename_inactive,
                livepackage_is_adult: adultSwitch,
                livepackage_no_expiry: expirySwitch,
                livepackage_channels_assign: channelsInPackage.join(),
                livepackage_display_while_inactive: null,
                livepackage_all_channel_image: null,
                livepackage_billing_code: this.state.livepackage_billing_code,
                livepackage_time_limit: this.state.livepackage_time_limit,
                livepackage_device_limit: this.state.livepackage_device_limit,
                livepackage_subscription_url: this.state.livepackage_subscription_url,
                livepackage_trial: trialSwitch,
                livepackage_content_provider: this.state.user_content_provider,
                custom_data: this.state.custom_data,

                livepackage_credit_card_status: creditCardSwitch,
                livepackage_credit_card_product_id: this.state.livepackage_credit_card_product_id,
                livepackage_credit_card_control_text: this.state.livepackage_credit_card_control_text,
                livepackage_credit_card_help_url: this.state.livepackage_credit_card_help_url,
                livepackage_code_status: codeSwitch,
                livepackage_code_control_text: this.state.livepackage_code_control_text,
                livepackage_code_help_url: this.state.livepackage_code_help_url,
                livepackage_account_status: accountSwitch,
                livepackage_access_visibility: this.state.accessVisibilitySwitch === false ? 0 : 1,
                livepackage_account_control_text: this.state.livepackage_account_control_text,
                livepackage_account_help_url: this.state.livepackage_account_help_url,
                livepackage_pgroups_codes: this.state.live_pgroups_codes !== null ? this.state.live_pgroups_codes.join() : null,
                livepackage_pgroups_cards: this.state.live_pgroups_cards !== null ? this.state.live_pgroups_cards.join() : null,

                livepackage_country_block_status: countryBlockStatus,
                livepackage_country_block_countries: this.state.livepackage_country_block_countries === null ? null : this.state.livepackage_country_block_countries.join(','),
                livepackage_device_type_visibility: Array.isArray(this.state.livepackage_device_type_visibility) ? this.state.livepackage_device_type_visibility.join(',') : null,
            }
        };

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        apiClient.put(url, postData, axiosConfig)
            .then((res) => {

                if (res.data.error === 301) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else if (res.data.error === 302) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else {
                    this.setState({loading: false})
                    this.notification("success")
                }

            })
            .catch((err) => {
                console.log("ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    createLivePackage() {

        this.setState({loading: true})

        const url = process.env.REACT_APP_API_URL + "/LivePackage";

        let channelsInPackage = []

        for (let i = 0; i < this.state.assignedChannelsInPackage.length; i++) {
            channelsInPackage.push(this.state.assignedChannelsInPackage[i])
        }

        let status = this.state.statusSwitch === false ? 0 : 1
        let adultSwitch = this.state.adultSwitch === false ? 0 : 1
        let expirySwitch = this.state.expirySwitch === false ? 0 : 1
        let trialSwitch = this.state.trialSwitch === false ? 0 : 1
        let creditCardSwitch = this.state.creditCardSwitch === false ? 0 : 1
        let codeSwitch = this.state.codeSwitch === false ? 0 : 1
        let accountSwitch = this.state.accountSwitch === false ? 0 : 1
        let countryBlockStatus = this.state.countryBlockSwitch === false ? 0 : 1

        //RENAME FUNCTIONS START IMAGE ACTIVE
        let filename_active = ""

        if (this.state.livepackage_image_temp) {
            let timeUTC = new Date().getTime()
            filename_active = timeUTC + "_" + this.state.livepackage_image
            this.setState({livepackage_image: filename_active})
            console.log("*****" + filename_active)
            this.submitActiveImage(filename_active);
        } else {
            filename_active = this.state.livepackage_image
        }

        //RENAME FUNCTIONS START IMAGE INACTIVE
        let filename_inactive = ""

        if (this.state.livepackage_inactive_image_temp) {
            let timeUTC = new Date().getTime()
            filename_inactive = timeUTC + "_" + this.state.livepackage_inactive_image
            this.setState({livepackage_inactive_image: filename_inactive})
            console.log("*****" + filename_inactive)
            this.submitInactiveImage(filename_inactive);
        } else {
            filename_inactive = this.state.livepackage_inactive_image
        }

        var postData = {
            live_package: {
                livepackage_name: this.state.livepackage_name,
                livepackage_name_long: this.state.livepackage_name_long,
                livepackage_description: this.state.livepackage_description,
                livepackage_status: status,
                livepackage_price: this.state.livepackage_price,
                livepackage_duration: this.state.livepackage_duration,
                livepackage_image: filename_active,
                livepackage_inactive_image: filename_inactive,
                livepackage_is_adult: adultSwitch,
                livepackage_no_expiry: expirySwitch,
                livepackage_channels_assign: channelsInPackage.join(),
                livepackage_display_while_inactive: null,
                livepackage_billing_code: this.state.livepackage_billing_code,
                livepackage_time_limit: this.state.livepackage_time_limit,
                livepackage_device_limit: this.state.livepackage_device_limit,
                livepackage_subscription_url: this.state.livepackage_subscription_url,
                livepackage_trial: trialSwitch,
                livepackage_content_provider: this.state.user_content_provider,

                livepackage_credit_card_status: creditCardSwitch,
                livepackage_credit_card_product_id: this.state.livepackage_credit_card_product_id,
                livepackage_credit_card_control_text: this.state.livepackage_credit_card_control_text,
                livepackage_credit_card_help_url: this.state.livepackage_credit_card_help_url,
                livepackage_code_status: codeSwitch,
                livepackage_code_control_text: this.state.livepackage_code_control_text,
                livepackage_code_help_url: this.state.livepackage_code_help_url,
                livepackage_account_status: accountSwitch,
                livepackage_account_control_text: this.state.livepackage_account_control_text,
                livepackage_account_help_url: this.state.livepackage_account_help_url,
                livepackage_pgroups_codes: this.state.live_pgroups_codes !== null ? this.state.live_pgroups_codes.join() : null,
                livepackage_pgroups_cards: this.state.live_pgroups_cards !== null ? this.state.live_pgroups_cards.join() : null,

                livepackage_country_block_status: countryBlockStatus,
                livepackage_country_block_countries: this.state.livepackage_country_block_countries === null ? null : this.state.livepackage_country_block_countries.join(','),
                livepackage_device_type_visibility: Array.isArray(this.state.livepackage_device_type_visibility) ? this.state.livepackage_device_type_visibility.join(',') : null,
            }
        };

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        apiClient.post(url, postData, axiosConfig)
            .then((res) => {
                this.setState({loading: false})

                if (res.data.error === 301) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else if (res.data.error === 302) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else {
                    const livePackageObject = res.data;
                    this.setState({livepackage_id: livePackageObject.livepackage_id, loading: false})
                    this.notification("success")
                    this.setLivePackageRedirect();
                }

            })
            .catch((err) => {
                console.log("ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    submitActiveImage(filename_active) {

        const imageUploadUrl = process.env.REACT_APP_IMAGE_SUBMIT_API_URL;

        if (this.state.livepackage_image_temp) {

            let bodyFormData = new FormData();
            bodyFormData.set('filepond[]', this.state.livepackage_image_folder_temp);
            bodyFormData.set('location', "package_live");
            bodyFormData.set('filename', filename_active);

            apiClient.post(imageUploadUrl, bodyFormData)
                .then((res) => {
                    this.setState({livepackage_image_temp: false})
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                })
        }

    }

    submitInactiveImage(filename_inactive) {

        const imageUploadUrl = process.env.REACT_APP_IMAGE_SUBMIT_API_URL;

        if (this.state.livepackage_inactive_image_temp) {

            let bodyFormData = new FormData();
            bodyFormData.set('filepond[]', this.state.livepackage_inactive_image_folder_temp);
            bodyFormData.set('location', "package_live");
            bodyFormData.set('filename', filename_inactive);


            apiClient.post(imageUploadUrl, bodyFormData)
                .then((res) => {
                    this.setState({livepackage_inactive_image_temp: false})
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                })
        }

    }

    setSaveModal = (value, action) => {

        this.setState({
            showSaveModal: value

        })

        if (action === "save") {
            this.setState({loading: true})

            const {handle} = this.props.match.params

            if (handle === 'new') {
                this.createLivePackage();
            } else {
                this.updateLivePackage();
            }
        }
    }

    cancelLivePackageEdit() {
        this.setRedirect();
    }

    setLivePackageRedirect = () => {
        this.setState({
            livePackageRedirect: true,
            back_button_text: "Back"
        })
    }

    renderSaveModal = () => {

        if (this.state.showSaveModal) {
            return <ModalSave
                headerMessage={"Live Package: "}
                bodyMessage={"this action will save all changes, click close to cancel saving"}
                handlerFromParent={this.setSaveModal}
                handlerID={this.state.livepackage_id === 0 ? '' : this.state.livepackage_id}
            />
        }

    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {

        let path = "/packages/tv-package";
        let pathLivePackage = "/edit-live-package/" + this.state.livepackage_id;

        if (this.state.redirect) {
            return <Redirect push to={path}/>
        }

        if (this.state.livePackageRedirect) {
            return <Redirect push to={pathLivePackage}/>
        }

    }

    renderSelection = () => {

        return (
            <Card

                content={
                    <div>
                        <h5>Channels Selection</h5>
                        <legend/>
                        <Grid fluid>
                            <Row>
                                <DualListBoxPackageLive
                                    channelsInPackage={this.state.assignedChannelsInPackage}
                                    packageID={this.state.livepackage_id}
                                    handlerFromParent={this.handleLivePackageChannelChange}
                                    eventProvider={this.state.user_content_provider}
                                    livePackageProvider={this.state.user_content_provider}
                                />
                            </Row>
                        </Grid>
                    </div>
                }
            />
        );

    }

    renderDurationFields = () => {

        if (!this.state.expirySwitch) {
            return (
                <FormGroup>
                    <ControlLabel>Duration (Days)</ControlLabel>
                    <FormControl placeholder="Enter the duration"
                                 type="number"
                                 name={"livepackage_duration"}
                                 disabled={this.state.loading}
                                 onChange={this.handleInputChange}
                                 value={this.state.livepackage_duration || ""}/>
                </FormGroup>
            );
        }


    }

    notification(status) {

        if (status === "success") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>Live package has been updated</b>
                    </div>
                ),
                level: 'success',
                position: 'tr',
                autoDismiss: 5,
            });
        }

        if (status === "failed") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>failed to update Live package</b>
                    </div>
                ),
                level: 'error',
                position: 'tr',
                autoDismiss: 10,
            });
        }

    }

    renderContentProvider = () => {

        if (this.state.current_user) {
            if (adminArray.includes(this.state.current_user.level)) {
                return (
                    <FormGroup>
                        <ControlLabel>Content Provider</ControlLabel>
                        <DropDownContentProviders
                            contentProviderSelected={this.state.user_content_provider}
                            name='contentProviderSelect'
                            handlerFromParent={this.handleChildContentProviderSelect}
                            disabled={this.state.loading}
                        />
                    </FormGroup>

                )
            }
        }

    }

    onClickAddAllCountriesCountryBlock() {

        this.setState({addAllCountriesInCountryBlock: true})

    }

    handleChildCountryBlockSelect(data) {

        let countryIDs = []
        let countryNames = []

        for (let i = 0; i < data.length; i++) {
            countryIDs.push(data[i].value)
        }

        for (let i = 0; i < data.length; i++) {
            countryNames.push(data[i].label)
        }

        //console.log(data);
        this.setState({
            livepackage_country_block_countries: data === null ? 0 : countryIDs, addAllCountriesInCountryBlock: false
        });
    }

    renderCountryBlockFields = () => {

        if (this.state.countryBlockSwitch) {
            return (
                <div>
                    <FormGroup>
                        <ControlLabel>Countries to block</ControlLabel>
                        <DropDownCountries
                            countrySelected={this.state.livepackage_country_block_countries}
                            name='countryBlockSelect'
                            handlerFromParent={this.handleChildCountryBlockSelect}
                            hadlerAddAllCountries={this.state.addAllCountriesInCountryBlock}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Button
                            onClick={this.onClickAddAllCountriesCountryBlock.bind(this)}
                        >
                            Add All countries
                        </Button>
                    </FormGroup>

                    <Well><Glyphicon glyph="question-sign"/> By enabling the Country Block
                        functionality,the live channels will be hidden for the countries specified.
                    </Well>
                </div>
            );
        }
    }

    renderCreditCardFields = () => {


        if (this.state.creditCardSwitch) {
            return (
                <div>

                    <FormGroup>
                        <ControlLabel>Credit Card Control Text</ControlLabel>
                        <FormControl placeholder="Enter credit card control text"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_credit_card_control_text"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_credit_card_control_text || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Credit Card product ID</ControlLabel>
                        <FormControl placeholder="Enter credit card product id"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_credit_card_product_id"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_credit_card_product_id || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Credit Card Help URL</ControlLabel>
                        <FormControl placeholder="Enter credit card help url"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_credit_card_help_url"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_credit_card_help_url || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Card price groups</ControlLabel>
                        <DropDownLiveTvPriceList
                            priceGroupsSelected={this.state.live_pgroups_cards}
                            name='liveCardPriceGroupsSelected'
                            handlerFromParent={this.handleChildLivePriceGroupsCreditCardSelected}
                            disabled={this.state.loading}
                        />
                    </FormGroup>

                </div>
            );
        }
    }

    renderCodeFields = () => {


        if (this.state.codeSwitch) {
            return (
                <div>

                    <FormGroup>
                        <ControlLabel>Code Control Text</ControlLabel>
                        <FormControl placeholder="Enter code control text"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_code_control_text"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_code_control_text || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Code Help URL</ControlLabel>
                        <FormControl placeholder="Enter code help url"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_code_help_url"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_code_help_url || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Code price groups</ControlLabel>
                        <DropDownLiveTvPriceList
                            priceGroupsSelected={this.state.live_pgroups_codes}
                            name='liveCodePriceGroupsSelected'
                            handlerFromParent={this.handleChildLivePriceGroupsCodesSelected}
                            disabled={this.state.loading}
                        />
                    </FormGroup>

                </div>
            );
        }
    }

    renderAccountFields = () => {

        if (this.state.accountSwitch) {
            return (
                <div>

                    <FormGroup>
                        <ControlLabel>Account Control Text</ControlLabel>
                        <FormControl placeholder="Enter account control text"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_account_control_text"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_account_control_text || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Account Help URL</ControlLabel>
                        <FormControl placeholder="Enter account help url"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="livepackage_account_help_url"
                                     onChange={this.handleInputChange}
                                     value={this.state.livepackage_account_help_url || ""}
                        />
                    </FormGroup>

                </div>
            );
        }
    }

    render() {
        return (
            <div className="main-content">

                <NotificationSystem ref="notificationSystem" style={style}/>

                {this.renderRedirect()}
                {this.renderSaveModal()}


                <div className="sweet-loader">
                    <ScaleLoader
                        css={override}
                        color={'#797979'}
                        loading={this.state.loading}
                    />
                </div>


                <Grid fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <Card
                                content={
                                    <div>
                                        <h5>Live Package Information</h5>
                                        <legend/>
                                        <FormGroup>
                                            <Row>
                                                <Col md={3}>
                                                    <ControlLabel>Status</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"statusSwitch"}
                                                        disabled={this.state.loading}
                                                        value={this.state.statusSwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <ControlLabel>No Expiry</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"expirySwitch"}
                                                        disabled={this.state.loading}
                                                        value={this.state.expirySwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <ControlLabel>Trial</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"trialSwitch"}
                                                        disabled={this.state.loading || this.state.expirySwitch}
                                                        value={this.state.trialSwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <ControlLabel>Adult</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"adultSwitch"}
                                                        disabled={this.state.loading}
                                                        value={this.state.adultSwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Short Name</ControlLabel>
                                            <FormControl placeholder="Enter Short Name"
                                                         type="text"
                                                         name={"livepackage_name"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.livepackage_name || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Long Name</ControlLabel>
                                            <FormControl placeholder="Enter Long Name"
                                                         type="text"
                                                         name={"livepackage_name_long"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.livepackage_name_long || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Description</ControlLabel>
                                            <FormControl componentClass="textarea"
                                                         type="text"
                                                         rows={4}
                                                         name="livepackage_description"
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         placeholder="Enter the description"
                                                         value={this.state.livepackage_description || ""}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Reference ID</ControlLabel>
                                            <FormControl placeholder="Enter the price"
                                                         type="text"
                                                         name={"livepackage_billing_code"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.livepackage_billing_code || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Price</ControlLabel>
                                            <FormControl placeholder="Enter the price"
                                                         type="number"
                                                         name={"livepackage_price"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.livepackage_price || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>External URL</ControlLabel>
                                            <InputGroup>
                                                <InputGroup.Addon style={{backgroundColor: "lightgray"}}>
                                                    <Glyphicon glyph="globe"/>
                                                </InputGroup.Addon>
                                                <FormControl
                                                    placeholder={this.props.t('packages_svod_edit.livepackage_subscription_url_placeholder', {framework: "react-i18next"})}
                                                    type="text"
                                                    name="livepackage_subscription_url"
                                                    disabled={this.state.loading}
                                                    onChange={this.handleInputChange}
                                                    value={this.state.livepackage_subscription_url || ""}
                                                />
                                            </InputGroup>
                                        </FormGroup>


                                        {this.renderDurationFields()}

                                        {this.renderContentProvider()}

                                        <FormGroup>
                                            <ControlLabel>Access Visibility</ControlLabel>
                                            <br/>
                                            <Switch
                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                                name='accessVisibilitySwitch'
                                                disabled={this.state.loading}
                                                value={this.state.accessVisibilitySwitch}
                                                defaultValue={false}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Device Type Visibility</ControlLabel>
                                            <Select
                                                value={this.state.livepackage_device_type_visibility}
                                                onChange={this.handleDeviceTypeChange}
                                                options={DeviceTypeOptions}
                                                multi={true}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Country Block</ControlLabel>
                                            <br/>
                                            <Switch
                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                                name='countryBlockSwitch'
                                                disabled={this.state.loading}
                                                value={this.state.countryBlockSwitch}
                                                defaultValue={false}
                                            />
                                        </FormGroup>

                                        {this.renderCountryBlockFields()}


                                        <div>
                                            <br/>
                                            <legend/>
                                            <ControlLabel>Credit Card</ControlLabel>
                                            <FormGroup>
                                                <Switch
                                                    onChange={(el, state) => this.handleSwitch(el, state)}
                                                    name='creditCardSwitch'
                                                    disabled={this.state.loading}
                                                    value={this.state.creditCardSwitch}
                                                    defaultValue={false}
                                                />
                                            </FormGroup>
                                            {this.renderCreditCardFields()}
                                        </div>

                                        <div>
                                            <br/>
                                            <legend/>
                                            <ControlLabel>Codes</ControlLabel>
                                            <FormGroup>
                                                <Switch
                                                    onChange={(el, state) => this.handleSwitch(el, state)}
                                                    name='codeSwitch'
                                                    disabled={this.state.loading}
                                                    value={this.state.codeSwitch}
                                                    defaultValue={false}
                                                />
                                            </FormGroup>
                                            {this.renderCodeFields()}
                                        </div>

                                        <div>
                                            <br/>
                                            <legend/>
                                            <ControlLabel>Account</ControlLabel>
                                            <FormGroup>
                                                <Switch
                                                    onChange={(el, state) => this.handleSwitch(el, state)}
                                                    name='accountSwitch'
                                                    disabled={this.state.loading}
                                                    value={this.state.accountSwitch}
                                                    defaultValue={false}
                                                />
                                            </FormGroup>
                                            {this.renderAccountFields()}
                                        </div>

                                    </div>
                                }
                                ftTextCenter
                                legend={
                                    <div className="buttons-with-margin">
                                        <Button bsStyle="info" fill wd
                                                name={"saveButton"}
                                                disabled={this.state.loading}
                                                onClick={() => this.setState({showSaveModal: true})}
                                        >
                                            Save
                                        </Button>
                                        <Button bsStyle="default" fill wd
                                                name={"cancelButton"}
                                                disabled={this.state.loading}
                                                onClick={this.cancelLivePackageEdit.bind(this)}>
                                            {this.state.back_button_text}
                                        </Button>
                                    </div>
                                }
                            />
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6}>
                            <Card
                                content={
                                    <div>
                                        <h5>Assets</h5>
                                        <legend/>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="text-center">
                                                        <p>Active</p>
                                                    </div>
                                                    <ImageUpload
                                                        imageName={this.state.livepackage_image}
                                                        imageType="package_live"
                                                        imagePosition={"livepackage_image"}
                                                        imageTemp={this.state.livepackage_image_temp}
                                                        imageFolderTemp={this.state.livepackage_image_folder_temp}
                                                        handlerFromParent={this.handleChildImageSelect}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <div className="text-center">
                                                        <p>Inactive</p>
                                                    </div>
                                                    <ImageUpload
                                                        imageName={this.state.livepackage_inactive_image}
                                                        imageType="package_live"
                                                        imagePosition={"livepackage_inactive_image"}
                                                        imageTemp={this.state.livepackage_inactive_image_temp}
                                                        imageFolderTemp={this.state.livepackage_inactive_image_folder_temp}
                                                        handlerFromParent={this.handleChildImageSelect}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6}>
                            {this.renderSelection()}
                        </Col>

                    </Row>
                </Grid>

            </div>

        );
    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedEditPackagesLive = connect(mapStateToProps)(EditPackagesLive);
const connectedEditPackagesLiveTrans = withNamespaces('common')(connectedEditPackagesLive);
export {connectedEditPackagesLiveTrans as EditPackagesLive};
